var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"seo-row"}},[_c('div',{staticClass:"row"},_vm._l((_vm.routes),function(route){return _c('div',{key:route.name,staticClass:"col"},[_c('a',{attrs:{"href":route.path}},[_vm._v(_vm._s(route.meta.seoTitle))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }